import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="App-footer">
      <div className="App-footer-brand">
        <h2>You Are Art</h2>
        <p>Wearable art, original paintings, and limited edition prints.</p>
      </div>
      <nav className="App-footer-nav" aria-label="Footer navigation">
        <Link to="/">Home</Link>
        <Link to="/merch">Wearable Art & Thangz</Link>
        <Link to="/original-paintings-1">Original Paintings</Link>
        <Link to="/Prints">Limited Edition Prints</Link>
      </nav>
      <p className="App-footer-copyright">
        &copy; {new Date().getFullYear()} Reena Tolentino. All rights reserved.
      </p>
    </footer>
  );
};

export default Footer;
